/**
 * An intermediate type used by {@link actionFactory}
 *
 * @typedef ActionCreator
 * @param {SerializableKey} type
 * @param {SerializableKey} reducer
 * @returns {object}
 */
/**
 * An action creator with no payload.
 * @returns {ActionCreator}
 */
export function simpleAction() {
    return (type, reducer) => () => {
        return { reducer, type };
    };
}
/**
 * An action creator with a typed payload.
 *
 * @returns {ActionCreator}
 */
export function payloadAction() {
    return (type, reducer) => (payload) => ({
        type,
        reducer,
        payload,
    });
}
/**
 * An action creator with a handler function payload.
 *
 * @param handler like a reducer, a function taking the previous state and
 * arguments to the action creator to create a new state.
 * @returns {ActionCreator}
 */
export function handlerAction(handler) {
    return (type, reducer) => (args) => ({
        type,
        reducer,
        handler: (state) => handler(state, args),
    });
}
